import { useEffect, useState } from "react";
import usePost from "../../../hooks/usePost";
import { useLocation } from "react-router-dom";
import usePut from "../../../hooks/usePut";
import { STYLEOPTIONS } from "../../../routes/routes_name";

const UseFormStyleOptions = (props) => {
  const { isLoading, error, isSuccess, navigate, handlePost } = usePost();
  const {
    isLoading: isLoadingPut,
    error: errorPut,
    isSuccess: isSuccessPut,
    navigate: navigatePut,
    handlePut,
  } = usePut();

  const location = useLocation();

  const [form, setForm] = useState({});

  useEffect(() => {
    if (props.type === "post") {
      setForm({
        name: "",
        partId: "",
        frontName: "",
        backName: "",
        foldedName: "",
        fabric: [],
        icon: "",
      });
    } else {
      setForm({
        id: location.state?._id || "",
        name: location.state?.name || "",
        partId: location.state?.partId?._id || location.state?.partId || "",
        frontName: location.state?.frontName || "",
        backName: location.state?.backName || "",
        foldedName: location.state?.foldedName || "",
        fabric:
          location.state?.arrayOfFabric?.map((f) =>
            typeof f === "object" ? f._id : f,
          ) || [],
        icon: location.state?.icon || "",
      });
    }
  }, []);

  const handleSubmit = async (e) => {
    e.preventDefault();

    let params = {
      url: "/v1/style_options",
      form: {
        name: form.name,
        partId: form.partId,
        frontName: form.frontName || "",
        backName: form.backName || "",
        foldedName: form.foldedName || "",
        arrayOfFabric: form.fabric || [],
        icon: form.icon || null,
      },
      navigation: STYLEOPTIONS,
      titleSuccess: "Saved!",
      descSuccess: "Style Option data has been successfully saved.",
    };

    if (props.type === "post") {
      handlePost(params);
    } else {
      params.titleSuccess = "Edited!";
      params.descSuccess = "Style Option data has been successfully edited.";
      params.url = `/v1/style_options?_id=${form.id}`;
      handlePut(params);
    }
  };

  const handleChange = (props) => {
    const { id, value } = props.target;

    setForm({
      ...form,
      [id]: value,
    });
  };

  return {
    isLoading,
    isLoadingPut,
    form,
    handleChange,
    handleSubmit,
  };
};

export default UseFormStyleOptions;
